export default __webpack_public_path__ + "assets/778f2abf514d6d4956410e1a9dea71fb.svg";